(function (window, document) {
  var bindEvents = function bindEvents() {
    var a = document.querySelector('.endless-scrolling a[data-next]');
    if (a) {
      var loading = false;
      var clickHandler = function (e) {
        if(loading) {
          return;
        }
        e.preventDefault();
        e.currentTarget.blur();
        loading = true;
        $(this).addClass('loading disabled');
        fetch(e.currentTarget.href)
          .then(function (response) {
            return response.ok ? response.text() : new Error('Couldn\'t load page');
          })
          .then(function (text) {
            var html = $(text);
            var newPage = html.find('.post-feed-page .row');
            var container = $('.post-feed-page');
            container.append(newPage);
            var newPagination = html.find('.endless-scrolling');
            var oldPagination = $('.endless-scrolling');
            oldPagination.replaceWith(newPagination);
            new LazyLoad({
              elements_selector: ".lazy",
              delay: 100
            });
            bindEvents();
          });
      };
      a.addEventListener('click', clickHandler);
    }
  };

  document.addEventListener('DOMContentLoaded', bindEvents);
})(window, document);
